import { DataFetchWrapper } from "@tfg/ui"

import { StandardMapping } from "~/pages/Brand/OrganizationSettings/Mapping/Standards/StandardsMapping.tsx"
import { useFindMappingByTypeQuery } from "~/pages/Brand/OrganizationSettings/Mapping/hooks/useFindMappingByTypeQuery.ts"

export const StandardMappingWrapper = () => {
  const query = useFindMappingByTypeQuery("STANDARD")

  return (
    <DataFetchWrapper query={query} acceptEmpty>
      {({ data }) => <StandardMapping standards={data.data} />}
    </DataFetchWrapper>
  )
}
